import React, { useState, useEffect } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { IoAddSharp } from 'react-icons/io5';
import { FaEye } from 'react-icons/fa';
import '../pagination/pagination.css';
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import PmUnitDetailForm from './pmUnitDetailForm';

// List of PM units with an Add button that opens the PM Unit Details popup.
// Double-click a row to edit that unit's details in the same popup.
const PmUnitDetailListing = () => {
  const apiService = new LeaseApiService();
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [showForm, setShowForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [viewOnly, setViewOnly] = useState(false);
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    setPermissions(stored.find((acc) => acc.formName === 'PM Unit Details') || null);
  }, []);

  useEffect(() => {
    getItems(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize]);

  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('UnitClass', 'PM');
      const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
      setRowData(res?.data?.result || []);
      setPagination(res?.data?.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const columnDefs = [
    {
      headerName: '',
      field: 'ref_No',
      colId: 'view',
      pinned: 'left',
      width: 60,
      sortable: false,
      filter: false,
      suppressMovable: true,
      cellRenderer: (params) => (
        permissions?.canView === true && (
        <button type="button" className="btn btn-sm btn-outline-secondary py-0" title="View" aria-label="View" onClick={() => openView(params.data)}>
          <FaEye />
        </button>
        )
      ),
    },
    { headerName: 'Ref no', field: 'ref_No', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
    { headerName: 'Property Name', field: 'property_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 220 },
    { headerName: 'Unit No', field: 'unit_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Class', field: 'unit_Class', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Unit Type', field: 'unit_Type', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
    { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Rent / Annum', field: 'rent_Per_Annum', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
    { headerName: 'Property No', field: 'property_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
  ];

  const openNew = () => {
    setSelectedRow(null);
    setViewOnly(false);
    setShowForm(true);
  };
  const openEdit = (row) => {
    if (permissions?.canUpdate !== true) return;
    setSelectedRow(row);
    setViewOnly(false);
    setShowForm(true);
  };
  const openView = (row) => {
    setSelectedRow(row);
    setViewOnly(true);
    setShowForm(true);
  };

  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <h6 className="mb-0 center">PM Unit Details</h6>
        {permissions?.canAdd === true && (
          <button className="mainbtn" type="button" onClick={openNew}>
            <IoAddSharp size={20} className="me-1" />
            Add
          </button>
        )}
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="ag-theme-quartz" style={{ height: 650 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            loading={loading}
            enableFilter={true}
            floatingFilter={true}
            onRowDoubleClicked={(e) => openEdit(e.data)}
          />
        </div>
        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
      </div>
      <PmUnitDetailForm show={showForm} initialRow={selectedRow} viewOnly={viewOnly} onHide={() => setShowForm(false)} onSaved={() => getItems(pagination?.currentPage || 1)} />
    </div>
  );
};

export default PmUnitDetailListing;
